export default __webpack_public_path__ + "static/media/(12).ab67ecf5.jpeg";